/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Acquisitiocontacthistory2Inputs */

const de__field_acquisitiocontacthistory2 = /** @type {(inputs: _Field_Acquisitiocontacthistory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktverlauf`)
};

/**

* @param {_Field_Acquisitiocontacthistory2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_acquisitiocontacthistory2 = /** @type {((inputs?: _Field_Acquisitiocontacthistory2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Acquisitiocontacthistory2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_acquisitiocontacthistory2(inputs)
});
export { _field_acquisitiocontacthistory2 as "_field_acquisitioContactHistory" }